import { AssetNameComponent } from '@/admins/SmartReports/components/Components/TextFields/AssetName';
import { TextAreaWithHeaderComponent } from '@/admins/SmartReports/components/Components/TextFields/TextAreaWithHeader';
import {
  CapexByYearStackedChartComponent,
  CashflowByYearStackedChartComponent,
  GasProductionByMonthStackedChartComponent,
  NpvByCountryComponent,
  NpvByProductionChartComponent,
  OilProductionByMonthStackedChartComponent,
  ProductionByMonthStackedByTypeChartComponent,
  ProductionByMonthStackedByTypeTotalChartComponent,
  ProductionByMonthStackedChartComponent,
  RemainingReservesBaseCaseDonutChartComponent,
  ReservesByCountryStackedByDevelopmentStatus,
  ReservesByCountryStackedByType,
} from './Charts';
import { AssetViewPictureComponent, CountryViewPictureComponent } from './Images';
import {
  AssetFeaturesTableComponent,
  AssetReservesTableComponent,
  FinancialConsiderationsTableComponent,
  HistoricalParticipationTableComponent,
  ReservoirCharacteristicsTableComponent,
  WellStatisticsTableComponent,
} from './Tables';
import { ProductionTableComponent } from './Tables/ProductionTable';
import { CompanyNameComponent } from './TextFields/CompanyName';
import { TextAreaComponent } from './TextFields/TextArea';

const CommonReportComponents = [TextAreaComponent, TextAreaWithHeaderComponent];

const CorporateReportComponents = [
  RemainingReservesBaseCaseDonutChartComponent,
  CompanyNameComponent,
  ProductionTableComponent,
  NpvByCountryComponent,
  NpvByProductionChartComponent,
  GasProductionByMonthStackedChartComponent,
  OilProductionByMonthStackedChartComponent,
  CashflowByYearStackedChartComponent,
  ProductionByMonthStackedChartComponent,
  CapexByYearStackedChartComponent,
  ReservesByCountryStackedByDevelopmentStatus,
  ReservesByCountryStackedByType,
];

const AssetReportComponents = [
  AssetNameComponent,
  AssetViewPictureComponent,
  CountryViewPictureComponent,
  AssetFeaturesTableComponent,
  AssetReservesTableComponent,
  FinancialConsiderationsTableComponent,
  HistoricalParticipationTableComponent,
  ReservoirCharacteristicsTableComponent,
  ProductionByMonthStackedByTypeChartComponent,
  ProductionByMonthStackedByTypeTotalChartComponent,
  WellStatisticsTableComponent,
];

export const SmartReportComponents = [
  ...CommonReportComponents,
  ...CorporateReportComponents,
  ...AssetReportComponents,
];
